
import { useState } from "react";
import { RichTextEditor } from "./RichTextEditor";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { ImageUploader } from "./ImageUploader";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/components/ui/use-toast";

interface BlogPostFormProps {
  initialData?: {
    title: string;
    description: string;
    content: string;
    category: string;
    image_url?: string;
  };
  onSubmit: (data: {
    title: string;
    description: string;
    content: string;
    category: string;
    image_url?: string;
  }) => void;
  isLoading?: boolean;
}

export const BlogPostForm = ({ initialData, onSubmit, isLoading }: BlogPostFormProps) => {
  const [formData, setFormData] = useState({
    title: initialData?.title || "",
    description: initialData?.description || "",
    content: initialData?.content || "",
    category: initialData?.category || "",
    image_url: initialData?.image_url || "",
  });

  const handleImageUploaded = (url: string) => {
    setFormData(prev => ({
      ...prev,
      image_url: url
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="title">Title</Label>
        <Input
          id="title"
          value={formData.title}
          onChange={(e) => setFormData({ ...formData, title: e.target.value })}
          placeholder="Enter post title"
          required
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="category">Category</Label>
        <Input
          id="category"
          value={formData.category}
          onChange={(e) => setFormData({ ...formData, category: e.target.value })}
          placeholder="Enter post category"
          required
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="description">Description</Label>
        <Textarea
          id="description"
          value={formData.description}
          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
          placeholder="Enter post description"
          required
        />
      </div>

      <div className="space-y-2">
        <Label>Featured Image</Label>
        <ImageUploader 
          initialImage={formData.image_url} 
          onImageUploaded={handleImageUploaded} 
        />
      </div>

      <div className="space-y-2">
        <Label>Content</Label>
        <div className="border rounded-md">
          <RichTextEditor
            content={formData.content}
            onChange={(content) => setFormData({ ...formData, content })}
          />
        </div>
      </div>

      <Button type="submit" disabled={isLoading}>
        {isLoading ? "Saving..." : "Save Post"}
      </Button>
    </form>
  );
};
